<div class="modal-header">
    <h4 class="modal-title fw-bold" jhiTranslate="inventoryManagerApp.lot.update.title">Update lots</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row" *ngIf="lotUUIDs && lotUUIDs.length === 1">
            <label class="col-4 col-form-label" jhiTranslate="inventoryManagerApp.lot.stock.id">
                Stock-id
            </label>
            <div class="col-4 col-form-label">
                {{lotUpdate.stockId}}
            </div>
        </div>
        <div class="mb-3 row">
            <label for="gid" class="col-4 col-form-label">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="gidLabel" [(ngModel)]="gidLabelCheck" #gidLabel>
                    <label class="form-check-label" for="gidLabel" jhiTranslate="inventoryManagerApp.lot.gid">
                        GID
                    </label>
                </div>
            </label>
            <div class="col-4">
                <input type="text" class="form-control" pattern="^[\d]+([\d]+)*$" name="gid" id="gid" [(ngModel)]="lotUpdate.gid"
                       [disabled]="!gidLabel.checked" required />
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-4 col-form-label">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="storageLocationLabel" [(ngModel)]="storageLocationLabelCheck" #storageLocationLabel>
                    <label class="form-check-label" for="storageLocationLabel" jhiTranslate="inventoryManagerApp.lot.locationName">
                        Storage Location
                    </label>
                </div>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <!-- TODO create reusable directive -->
                    <ng-select *ngIf="!useFavoriteLocations" name="storageLocation" id="storageLocation"
                               [(ngModel)]="storageLocIdSelected"
                               [disabled]="!storageLocationLabel.checked" required>
                        <ng-option *ngFor="let location of storageLocations | async" [value]="location.id">
                            {{ location.name }}
                        </ng-option>
                    </ng-select>
                    <ng-select *ngIf="useFavoriteLocations" name="favoriteLocation" id="favoriteLocation"
                               [(ngModel)]="favoriteLocIdSelected"
                               [disabled]="!storageLocationLabel.checked" required>
                        <ng-option *ngFor="let location of favoriteLocations | async" [value]="location.id">
                            {{ location.name }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" name="useFavoriteLocations" id="useFavoriteLocations" [(ngModel)]="useFavoriteLocations"
                                   [disabled]="!storageLocationLabel.checked">
                            <label class="form-check-label" for="useFavoriteLocations" jhiTranslate="inventoryManagerApp.lot.locationName.favorite">
                                Favorite locations only
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="unitId" class="col-4 col-form-label">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="unitsLabel" [(ngModel)]="unitsLabelCheck" #unitsLabel>
                    <label class="form-check-label" for="unitsLabel" jhiTranslate="inventoryManagerApp.lot.unitName">
                        Units
                    </label>
                </div>
            </label>
            <div class="col-4">
                <select class="form-select" name="unitId" id="unitId" [(ngModel)]="lotUpdate.unitId"
                        [disabled]="!unitsLabel.checked" required>
                    <option *ngFor="let unit of units | async" [value]="unit.id">
                        <label>{{unit.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="notes" class="col-4">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="notesLabel" [(ngModel)]="notesLabelCheck" #notesLabel>
                    <label class="form-check-label" for="notesLabel" jhiTranslate="inventoryManagerApp.lot.adjustment.notes">
                        Notes
                    </label>
                </div>
            </label>
            <div class="col-4">
                 <textarea class="form-control " rows="3" name="notes" id="notes" [(ngModel)]="lotUpdate.notes" jhi-forbiddenCharactersValidator
                           [disabled]="!notesLabel.checked" required></textarea>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button (click)="update(f)" [disabled]="!isFormValid(f)" class="btn btn-primary">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.update">Update</span>
    </button>
</div>
